import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { getCall } from './api-calls/apicalls.service';
import { HeadersService } from './api-calls/headers.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationService extends HeadersService {
    constructor(public _http: HttpClient) {
        super(_http);
    }

    /**
     *
     * @param status 'received' | 'deleted' | 'readed'
     */
    getNotifications(status: string = null) {
        let url: string;
        if (!status) {
            url = getCall('notifications', null, {
                access: localStorage.getItem('user-access'),
            });
        } else {
            url = getCall('notifications', null, {
                access: localStorage.getItem('user-access'),
                status: status,
            });
        }

        return this._http.get(url, this.getHeaders());
    }

    /**
     *
     * @param notificationId number
     * @param status 'received' | 'deleted' | 'readed'
     */
    setNotificationStatus(notificationId: number, status: string) {
        const url = getCall('notifications', notificationId, {
            access: localStorage.getItem('user-access'),
        });

        const data = {
            status: status,
        };

        return this._http.patch(url, data, this.getHeaders());
    }

    bulkNotifications(status: string) {
        const url = getCall('notificationsBulk', null, {
            access: localStorage.getItem('user-access'),
        });

        const data = {
            status: status,
        };

        return this._http.post(url, data, this.getHeaders());
    }

    loadMore(url: string) {
        return this._http.get(url, this.getHeaders());
    }
}
